const indigo = {
    100: 'rgb(116, 146, 210)',
    200: 'rgb(60, 100, 185)',
    300: 'rgb(50, 83, 154)',
    400: 'rgb(40, 66, 123)',
    500: 'rgb(30, 50, 92)',
    600: 'rgb(20, 33, 62)',
    700: 'rgb(15, 25, 46)',
    800: 'rgb(10, 17, 31)',
};
export default indigo;
